/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-18 10:15:54
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-08-18 14:04:28
 * @FilePath: /qd-yunjing-web/src/router/modules/system.ts
 * @Description: 这是默认设置,请设置`customMade
 */
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

const { VITE_APP_ACCOUNT_URL } = import.meta.env;

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/account',
    name: 'account-root',
    component: Layout,
    meta: {
      authCodes: ['ACCOUNT'],
      title: '账号',
    },
    children: [
      {
        path: '/roleManage/index',
        name: 'role-manage-index',
        meta: {
          authCodes: ['ROLE_MANAGE'],
          title: '角色管理',
          activeMenu: '/user',
          isTabsMenu: false,
          iframeSrc: `${VITE_APP_ACCOUNT_URL}/base/role`,
        },
        component: () => import('@/layouts/iframe/index.vue'),
      },
      {
        path: '/organizationalManage/index',
        name: 'organizational-manage-index',
        meta: {
          authCodes: ['ORGANIZATIONAL_MANAGE'],
          title: '组架管理',
          activeMenu: '/user',
          isTabsMenu: false,
          iframeSrc: `${VITE_APP_ACCOUNT_URL}/base/personnel?menuId=1955108182027726848`,
        },
        component: () => import('@/layouts/iframe/index.vue'),
      }
    ],
  }

];
